import { render, staticRenderFns } from "./ConsultarEstadoPago.vue?vue&type=template&id=82dd23c2&scoped=true"
import script from "./ConsultarEstadoPago.vue?vue&type=script&lang=js"
export * from "./ConsultarEstadoPago.vue?vue&type=script&lang=js"
import style0 from "./ConsultarEstadoPago.vue?vue&type=style&index=0&id=82dd23c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dd23c2",
  null
  
)

export default component.exports